<template>
  <div class="tx-progress flex justify-center">
    <div class="tx-progress__container" :style="{ maxWidth: maxWidth ? `${maxWidth}px` : false }">
      <div class="tx-progress__bar">
        <div
          class="tx-progress__fill"
          :class="{
            'tx-progress__fill--success': completed && !revert,
            'tx-progress__fill--revert': revert
          }"
          :style="{ width: progress }"
        ></div>
      </div>
      <div v-if="showInfo" class="flex" :class="completed ? 'justify-center' : 'justify-between'">
        <template v-if="!completed">
          <small>Transaction pending...</small>
          <small>{{ elapsedTime }}</small>
        </template>
        <small v-else-if="revert" class="color-red">Transaction reverted</small>
        <small v-else class="color-green">Transaction success!</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tx: {
      type: String,
      required: true
    },
    expectedMs: {
      type: Number,
      default: 30000
    },
    maxWidth: {
      type: Number,
      default: 200
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    stallPercent: {
      type: Number,
      default: 95
    }
  },

  data: () => ({
    completed: false,
    revert: false,
    startTime: Date.now(),
    currentTime: Date.now(),
    checkTxID: null
  }),

  computed: {
    elapsedTime() {
      let seconds = Math.floor((this.currentTime - this.startTime) / 1000)
      const minutes = Math.floor(seconds / 60)
      seconds = ("0" + (seconds % 60)).substr(-2)

      return `${minutes}:${seconds}`
    },

    progress() {
      if (this.completed) return "100%"

      const elapsedMs = this.currentTime - this.startTime
      const percent = Math.floor(this.stallPercent * Math.min(1, elapsedMs / this.expectedMs))

      return `${percent}%`
    }
  },

  beforeDestroy() {
    clearInterval(this.checkTxID)
  },

  watch: {
    tx: {
      handler: "resetProgress",
      immediate: true
    }
  },

  methods: {
    checkTx() {
      if (!this.tx) return

      this.currentTime = Date.now()

      if (!this.$store.state.web3.instance) return

      const web3 = this.$store.state.web3.instance()
      web3.eth.getTransactionReceipt(this.tx, (err, res) => {
        if (err) return

        if (res && res.blockNumber) {
          this.completed = true
          this.$emit("mined")
          clearInterval(this.checkTxID)

          if (res.status === "0x0") {
            this.revert = true
            this.$emit("revert")
          } else {
            this.$emit("success")
          }
        }
      })
    },

    resetProgress() {
      this.completed = false
      this.revert = false

      this.startTime = Date.now()
      this.currentTime = Date.now()

      clearInterval(this.checkTxID)
      this.checkTxID = setInterval(this.checkTx, 1000)
      this.checkTx()
    }
  }
}
</script>

<style lang="scss">
.tx-progress {
  &__container {
    width: 100%;
  }

  &__bar {
    overflow: hidden;

    width: 100%;
    height: 8px;

    border-radius: 4px;
    background: var(--stroke);
  }

  &__fill {
    height: 100%;

    border-radius: 4px;
    background: var(--highlight);

    transition: width 300ms linear, background 300ms ease;

    &--success {
      background: var(--success);
    }

    &--revert {
      background: var(--error);
    }
  }
}
</style>
